import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the public-facing base URL for shareable links.
 * Uses REACT_APP_PUBLIC_URL if set, otherwise falls back to window.location.origin.
 */
export function getPublicUrl() {
  return (process.env.REACT_APP_PUBLIC_URL || '').replace(/\/+$/, '') || window.location.origin;
}
